import React from "react";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Select } from "antd";
import { PERMISSION_ONE_QUERY, UPDATE_PERMISSION_MUTATION } from "./queries";
import { Permission } from "./interface";

const resources = [
  { label: "All", value: "*" },
  { label: "Procurement Plans", value: "procurementPlans" },
  { label: "Purchase Requests", value: "purchaseRequests" },
  { label: "Procurement Plan Reports", value: "procurementPlanReports" },
  { label: "Purchase Orders", value: "purchaseOrders" },
  { label: "Sourcings", value: "sourcings" },
  { label: "Receivings", value: "receivings" },
  { label: "Purchase Templates", value: "purchaseTemplates" },
  { label: "Document Templates", value: "documentTemplates" },
  { label: "Minute Templates", value: "minuteTemplates" },
  { label: "Invoices", value: "invoices" },
  { label: "Payment Requests", value: "paymentRequests" },
  { label: "Users", value: "users" },
  { label: "Teams", value: "teams" },
  { label: "Vendors", value: "vendors" },
  { label: "Default Committees", value: "defaultCommittees" },
  { label: "Permissions", value: "permissions" },
];

const actions = [
  { label: "All", value: "*" },
  { label: "Read", value: "read" },
  { label: "Create", value: "create" },
  { label: "Edit", value: "edit" },
  { label: "Delete", value: "delete" },
  { label: "Show", value: "show" },
  { label: "Approve", value: "approve" },
  { label: "Publish", value: "publish" },
  { label: "Assign", value: "assign" },
];

export const EditPermission: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<Permission>({
    resource: "permissions",
    action: "edit",
    meta: {
      gqlQuery: PERMISSION_ONE_QUERY,
      gqlMutation: UPDATE_PERMISSION_MUTATION,
    },
  });

  return (
    <Edit saveButtonProps={saveButtonProps} title="Edit Permission">
      <Form layout="vertical" {...formProps}>
        <Form.Item
          label="Resources"
          name="resources"
          rules={[{ required: true, message: "Please select at least one resource" }]}
        >
          <Select
            mode="multiple"
            placeholder="Select resources"
            options={resources}
            showSearch
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item
          label="Actions"
          name="actions"
          rules={[{ required: true, message: "Please select at least one action" }]}
        >
          <Select
            mode="multiple"
            placeholder="Select actions"
            options={actions}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Form.Item
          label="Organizational Roles"
          name="organizationalRoles"
          rules={[{ required: true, message: "Please enter at least one role" }]}
        >
          <Select
            mode="tags"
            placeholder="Enter role names"
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>
    </Edit>
  );
};
